export const heroSlides = [
  {
    id: 1,
    label: 'Home Cleaning',
    headline: 'A spotless home,\nevery single time.',
    body: 'Our trained professionals handle everything from daily tidying to deep sanitisation. Eco-friendly products, careful attention to detail, and flexible scheduling that works around your life.',
    image:
      'https://readdy.ai/api/search-image?query=Professional%20Nigerian%20woman%20in%20a%20green%20polo%20shirt%20smiling%20while%20mopping%20a%20modern%20Nigerian%20home%20living%20room%20with%20warm%20afternoon%20light%20streaming%20through%20windows%2C%20authentic%20domestic%20interior%20with%20family%20photos%20on%20wall%2C%20editorial%20documentary%20photography%20with%20natural%20skin%20tones%20and%20warm%20colors&width=1600&height=900&seq=hero-home-cleaning-01&orientation=landscape',
    features: ['Weekly & bi-weekly plans', 'Deep cleaning', 'Move-in/move-out'],
    priceFrom: '₦15,000',
  },
  {
    id: 2,
    label: 'Industrial Cleaning',
    headline: 'Workspaces that\nwork as hard as you.',
    body: 'From warehouses to corporate offices, our industrial teams use commercial-grade equipment to maintain safety-compliant environments. Scheduled daily, weekly, or on-demand.',
    image:
      'https://readdy.ai/api/search-image?query=Professional%20Nigerian%20man%20in%20a%20navy%20blue%20work%20uniform%20operating%20industrial%20floor%20cleaning%20machine%20in%20a%20large%20modern%20commercial%20warehouse%20with%20bright%20overhead%20lights%2C%20polished%20concrete%20floors%2C%20authentic%20working%20environment%2C%20editorial%20documentary%20photography%20with%20natural%20warm%20tones&width=1600&height=900&seq=hero-industrial-cleaning-01&orientation=landscape',
    features: ['OSHA-compliant protocols', 'Floor restoration', 'After-hours service'],
    priceFrom: '₦50,000',
  },
  {
    id: 3,
    label: 'Waste Pickup & Management',
    headline: 'Responsible disposal.\nCleaner streets.',
    body: 'Scheduled residential and commercial waste collection with sustainable sorting. We partner with recycling facilities across Lagos, Abuja, and Port Harcourt to keep communities clean.',
    image:
      'https://readdy.ai/api/search-image?query=Two%20Nigerian%20workers%20in%20safety%20vests%20and%20gloves%20loading%20sorted%20waste%20bins%20onto%20a%20modern%20green%20waste%20collection%20truck%20on%20a%20clean%20Nigerian%20residential%20street%20in%20the%20early%20morning%2C%20warm%20golden%20light%2C%20community%20environment%2C%20editorial%20documentary%20photography%20with%20natural%20warm%20tones%20and%20authentic%20feel&width=1600&height=900&seq=hero-waste-management-01&orientation=landscape',
    features: ['Daily & weekly pickup', 'Recycling sorting', 'Estate management'],
    priceFrom: '₦8,000/month',
  },
  {
    id: 4,
    label: 'Car Washing & Detailing',
    headline: 'Your car,\nshowroom clean.',
    body: 'Professional hand washing and interior detailing at your doorstep. We use water-saving techniques and eco-friendly products that protect your paint and the environment.',
    image:
      'https://readdy.ai/api/search-image?query=A%20stunning%20metallic%20charcoal%20Mercedes-Benz%20GLE%20being%20hand-washed%20by%20a%20professional%20detailer%20in%20a%20clean%20dark%20grey%20uniform%20on%20a%20bright%20sunlit%20driveway%20with%20modern%20Nigerian%20mansion%20architecture%20backdrop%2C%20thick%20white%20snow%20foam%20cascading%20down%20the%20glossy%20hood%20and%20windshield%2C%20water%20beads%20glistening%20in%20golden%20hour%20sunlight%2C%20palm%20trees%20softly%20blurred%20in%20background%2C%20cinematic%20automotive%20lifestyle%20photography%20with%20warm%20golden%20tones%2C%20ultra-detailed%20paint%20reflections%2C%20professional%20premium%20car%20care%20aesthetic&width=1600&height=900&seq=hero-car-washing-v2&orientation=landscape&nocache=true',
    features: ['Doorstep service', 'Interior & exterior', 'Eco-friendly wash'],
    priceFrom: '₦5,000',
  },
  {
    id: 5,
    label: 'Specialized Deep Cleaning',
    headline: 'When ordinary\nis not enough.',
    body: 'Post-construction sparkle, pre-event preparation, carpet restoration, and medical-grade sanitisation. Our specialists bring the tools and training for jobs that demand precision.',
    image:
      'https://readdy.ai/api/search-image?query=Close-up%20of%20hands%20of%20a%20Nigerian%20professional%20cleaner%20wearing%20rubber%20gloves%20meticulously%20cleaning%20a%20marble%20countertop%20with%20a%20microfiber%20cloth%20in%20a%20bright%20modern%20kitchen%2C%20steam%20visible%20in%20background%2C%20warm%20natural%20light%2C%20shallow%20depth%20of%20field%2C%20editorial%20documentary%20photography%20with%20warm%20skin%20tones&width=1600&height=900&seq=hero-deep-cleaning-01&orientation=landscape',
    features: ['Post-construction', 'Carpet & upholstery', 'Medical-grade sanitisation'],
    priceFrom: '₦25,000',
  },
];

export const services = [
  {
    id: 'home-cleaning',
    title: 'Home Cleaning',
    shortDesc: 'Regular upkeep, deep cleans, and move-in readiness for every room.',
    description:
      'From routine home upkeep to deep seasonal cleans, we treat every living space with meticulous care. Our trained crews use eco-conscious products that are safe for families and pets.',
    image:
      'https://readdy.ai/api/search-image?query=Pristine%20modern%20Nigerian%20home%20interior%20after%20professional%20cleaning%2C%20bright%20natural%20light%20streaming%20through%20large%20windows%2C%20spotless%20marble%20floors%20and%20fresh%20linens%2C%20warm%20neutral%20tones%2C%20editorial%20interior%20photography%20with%20soft%20shadows&width=900&height=650&seq=service-residential-01&orientation=landscape',
    areas: ['Lagos', 'Abuja', 'Port Harcourt'],
    priceFrom: '₦15,000',
    duration: '2–4 hours',
    cleaners: 2,
  },
  {
    id: 'industrial-cleaning',
    title: 'Industrial & Commercial',
    shortDesc: 'Warehouses, offices, and retail spaces maintained to the highest standards.',
    description:
      'Offices, retail spaces, and industrial facilities maintained to the highest standards. We build long-term partnerships with businesses across Nigeria.',
    image:
      'https://readdy.ai/api/search-image?query=Modern%20Nigerian%20office%20building%20lobby%20interior%20with%20professional%20cleaning%20crew%20working%2C%20gleaming%20glass%20and%20polished%20floors%2C%20warm%20ambient%20lighting%2C%20contemporary%20architecture%2C%20editorial%20corporate%20photography%20with%20clean%20aesthetic&width=900&height=650&seq=service-commercial-01&orientation=landscape',
    areas: ['Nationwide'],
    priceFrom: '₦50,000',
    duration: '4–8 hours',
    cleaners: 4,
  },
  {
    id: 'waste-management',
    title: 'Waste Pickup & Management',
    shortDesc: 'Scheduled collection and sustainable sorting for homes and businesses.',
    description:
      'Scheduled collection and sustainable sorting for residential estates, commercial properties, and community clean-up drives across Lagos, Abuja, and beyond.',
    image:
      'https://readdy.ai/api/search-image?query=Clean%20Nigerian%20residential%20estate%20with%20modern%20waste%20bins%20neatly%20arranged%2C%20green%20landscaping%2C%20morning%20light%2C%20editorial%20documentary%20photography%20with%20warm%20tones&width=900&height=650&seq=service-waste-01&orientation=landscape',
    areas: ['Lagos', 'Abuja', 'Port Harcourt'],
    priceFrom: '₦8,000/month',
    duration: 'Varies',
    cleaners: 1,
  },
  {
    id: 'car-washing',
    title: 'Car Washing & Detailing',
    shortDesc: 'Professional interior and exterior car cleaning at your doorstep.',
    description:
      'Full-service car washing including exterior hand wash, interior vacuum, dashboard polish, tyre dressing, and window cleaning. We come to your home, office, or preferred location with our own water and supplies. Water-saving foam technology keeps every wash eco-friendly.',
    image:
      'https://readdy.ai/api/search-image?query=Professional%20auto%20detailer%20in%20dark%20uniform%20meticulously%20polishing%20a%20glossy%20deep%20blue%20luxury%20sedan%20door%20panel%20with%20a%20plush%20microfiber%20cloth%2C%20mirror-like%20paint%20finish%20reflecting%20warm%20afternoon%20sunlight%20and%20blurred%20palm%20trees%2C%20water%20droplets%20still%20visible%20on%20the%20polished%20surface%2C%20shallow%20depth%20of%20field%20focusing%20on%20the%20hand%20and%20gleaming%20paintwork%2C%20rich%20warm%20golden%20hour%20lighting%2C%20cinematic%20automotive%20detailing%20photography%2C%20premium%20high-end%20aesthetic%20with%20natural%20Nigerian%20outdoor%20setting&width=900&height=650&seq=service-car-wash-v2&orientation=landscape&nocache=true',
    areas: ['Lagos', 'Abuja', 'Port Harcourt', 'Ibadan'],
    priceFrom: '₦5,000',
    duration: '1–2 hours',
    cleaners: 1,
  },
  {
    id: 'specialized-cleaning',
    title: 'Specialized Deep Cleaning',
    shortDesc: 'Post-construction, carpet restoration, and medical-grade sanitisation.',
    description:
      'Post-construction cleanup, move-in/move-out services, carpet and upholstery restoration, and sanitisation for healthcare and food-prep environments.',
    image:
      'https://readdy.ai/api/search-image?query=Close-up%20of%20professional%20cleaning%20equipment%20on%20spotless%20tile%20floor%2C%20steam%20cleaner%20and%20eco-friendly%20supplies%2C%20bright%20clinical%20lighting%2C%20shallow%20depth%20of%20field%2C%20editorial%20product%20photography%20with%20warm%20neutral%20background&width=900&height=650&seq=service-specialized-01&orientation=landscape',
    areas: ['Lagos', 'Abuja', 'Ibadan', 'Port Harcourt'],
    priceFrom: '₦25,000',
    duration: '3–6 hours',
    cleaners: 3,
  },
];

export const cleaners = [
  {
    id: 'c1',
    name: 'Blessing Adeyemi',
    role: 'Home Cleaning Specialist',
    image:
      'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20friendly%20Nigerian%20woman%20in%20her%20late%2020s%20wearing%20a%20light%20blue%20polo%20shirt%2C%20warm%20genuine%20smile%2C%20soft%20natural%20light%2C%20clean%20neutral%20background%2C%20editorial%20headshot%20photography%20with%20warm%20skin%20tones&width=400&height=400&seq=cleaner-blessing-01&orientation=squarish',
    rating: 4.9,
    jobs: 142,
  },
  {
    id: 'c2',
    name: 'Emmanuel Okonkwo',
    role: 'Industrial Cleaning Lead',
    image:
      'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20confident%20Nigerian%20man%20in%20his%20early%2030s%20wearing%20a%20navy%20blue%20work%20polo%2C%20friendly%20professional%20expression%2C%20soft%20natural%20light%2C%20clean%20neutral%20background%2C%20editorial%20headshot%20photography%20with%20warm%20skin%20tones&width=400&height=400&seq=cleaner-emmanuel-01&orientation=squarish',
    rating: 4.8,
    jobs: 98,
  },
  {
    id: 'c3',
    name: 'Fatima Ibrahim',
    role: 'Deep Cleaning Specialist',
    image:
      'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20warm%20Nigerian%20woman%20in%20her%20mid%2030s%20wearing%20a%20light%20blue%20uniform%20shirt%2C%20professional%20smile%2C%20soft%20natural%20light%2C%20clean%20neutral%20background%2C%20editorial%20headshot%20photography%20with%20warm%20skin%20tones&width=400&height=400&seq=cleaner-fatima-01&orientation=squarish',
    rating: 5.0,
    jobs: 76,
  },
  {
    id: 'c4',
    name: 'Chinedu Okafor',
    role: 'Waste Management Officer',
    image:
      'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20fit%20Nigerian%20man%20in%20his%20late%2020s%20wearing%20a%20green%20safety%20vest%20over%20a%20blue%20shirt%2C%20confident%20smile%2C%20soft%20natural%20light%2C%20clean%20neutral%20background%2C%20editorial%20headshot%20photography%20with%20warm%20skin%20tones&width=400&height=400&seq=cleaner-chinedu-01&orientation=squarish',
    rating: 4.9,
    jobs: 112,
  },
  {
    id: 'c5',
    name: 'Samuel Adeleke',
    role: 'Car Detailing Specialist',
    image:
      'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20friendly%20Nigerian%20man%20in%20his%20mid%2020s%20wearing%20a%20blue%20work%20polo%20shirt%2C%20confident%20smile%2C%20soft%20natural%20light%2C%20clean%20neutral%20background%2C%20editorial%20headshot%20photography%20with%20warm%20skin%20tones&width=400&height=400&seq=cleaner-samuel-01&orientation=squarish',
    rating: 4.9,
    jobs: 89,
  },
];

export const processSteps = [
  {
    number: '01',
    title: 'Book online, via mobile app or call',
    description:
      'Pick your service, schedule a time, and receive an instant confirmation. Our team is available six days a week across Lagos, Abuja, and Port Harcourt.',
    image:
      'https://readdy.ai/api/search-image?query=Close-up%20of%20hands%20holding%20a%20smartphone%20booking%20a%20service%20on%20a%20clean%20modern%20app%20interface%2C%20soft%20natural%20light%2C%20warm%20skin%20tones%2C%20minimal%20background%2C%20editorial%20lifestyle%20photography&width=600&height=600&seq=process-book-01&orientation=squarish',
  },
  {
    number: '02',
    title: 'We arrive prepared',
    description:
      'Our uniformed crew shows up on time with industrial-grade equipment and certified eco-friendly supplies. Every visit starts with a walkthrough.',
    image:
      'https://readdy.ai/api/search-image?query=Professional%20cleaning%20crew%20in%20matching%20uniforms%20arriving%20at%20a%20modern%20home%20entrance%20with%20equipment%20trolley%2C%20early%20morning%20golden%20light%2C%20confident%20posture%2C%20editorial%20documentary%20photography%20style&width=600&height=600&seq=process-arrive-01&orientation=squarish',
  },
  {
    number: '03',
    title: 'Inspect & sign off',
    description:
      'Once the job is done, we do a final walkthrough with you. No satisfaction, no payment. That is the CleanUp Naija guarantee.',
    image:
      'https://readdy.ai/api/search-image?query=Homeowner%20shaking%20hands%20with%20professional%20cleaner%20in%20a%20spotless%20living%20room%2C%20warm%20smiles%2C%20natural%20window%20light%2C%20genuine%20moment%20of%20trust%20and%20satisfaction%2C%20editorial%20lifestyle%20photography&width=600&height=600&seq=process-signoff-01&orientation=squarish',
  },
];

export const testimonials = [
  {
    id: 1,
    name: 'Amara Okafor',
    role: 'Homeowner, Lekki Phase 1',
    quote:
      'They transformed my apartment after a renovation. Every corner, every surface — spotless. I have been on their monthly plan for eight months now.',
    image:
      'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20confident%20Nigerian%20woman%20in%20her%2030s%20with%20natural%20hair%20and%20warm%20smile%2C%20wearing%20elegant%20casual%20attire%2C%20soft%20natural%20light%20from%20window%2C%20neutral%20warm%20background%2C%20editorial%20headshot%20photography&width=500&height=650&seq=testimonial-amara-01&orientation=portrait',
  },
  {
    id: 2,
    name: 'Tunde Bakare',
    role: 'Facilities Manager, Victoria Island',
    quote:
      'Managing a 40-person office is hard enough. CleanUp Naija handles our entire facility — restrooms, conference rooms, kitchen — and it is flawless every single day.',
    image:
      'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20professional%20Nigerian%20man%20in%20his%2040s%20with%20well-groomed%20beard%20and%20confident%20expression%2C%20wearing%20a%20crisp%20shirt%2C%20soft%20natural%20light%2C%20neutral%20warm%20background%2C%20editorial%20headshot%20photography&width=500&height=650&seq=testimonial-tunde-01&orientation=portrait',
  },
  {
    id: 3,
    name: 'Dr. Nkechi Emeka',
    role: 'Clinic Director, Garki',
    quote:
      'In a medical environment, sanitation is non-negotiable. Their team understands protocols, uses the right disinfectants, and documents everything. That professionalism matters.',
    image:
      'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20distinguished%20Nigerian%20woman%20in%20her%2050s%20with%20graceful%20demeanor%20and%20warm%20professional%20smile%2C%20wearing%20medical%20scrubs%20under%20a%20lab%20coat%2C%20soft%20natural%20light%2C%20neutral%20warm%20background%2C%20editorial%20headshot%20photography&width=500&height=650&seq=testimonial-nkechi-01&orientation=portrait',
  },
];

export const navLinks = [
  { label: 'Home', href: '#home', isScroll: true },
  { label: 'Services', href: '#services', isScroll: true, hasDropdown: true },
  { label: 'Process', href: '#process', isScroll: true },
  { label: 'FAQ', href: '#faq', isScroll: true },
  { label: 'Contact', href: '#contact', isScroll: true },
];

export const navServiceItems = [
  { label: 'Home Cleaning', href: '#services', scrollTo: 'home-cleaning' },
  { label: 'Industrial Cleaning', href: '#services', scrollTo: 'industrial-cleaning' },
  { label: 'Waste Management', href: '#services', scrollTo: 'waste-management' },
  { label: 'Car Washing & Detailing', href: '#services', scrollTo: 'car-washing' },
  { label: 'Specialized Deep Cleaning', href: '#services', scrollTo: 'specialized-cleaning' },
];

export const footerLinks = {
  services: [
    { label: 'Home Cleaning', href: '#services' },
    { label: 'Industrial Cleaning', href: '#services' },
    { label: 'Waste Management', href: '#services' },
    { label: 'Car Washing', href: '#services' },
    { label: 'Deep Cleaning', href: '#services' },
  ],
  company: [
    { label: 'About Us', href: '#home' },
    { label: 'Careers', href: '#home' },
    { label: 'Blog', href: '#home' },
  ],
  support: [
    { label: 'Contact', href: '#contact' },
    { label: 'FAQ', href: '#faq' },
  ],
};

export const trustItems = [
  {
    id: 'background',
    title: 'Background-Checked Crew',
    description: 'Every team member is thoroughly vetted, ID-verified, and reference-checked before they ever step into your space.',
  },
  {
    id: 'eco',
    title: 'Eco-Friendly Products',
    description: 'We use non-toxic, biodegradable cleaning agents that are safe for children, pets, and the environment. No harsh chemicals.',
  },
  {
    id: 'insurance',
    title: 'Fully Insured',
    description: 'Accidents are rare, but peace of mind is priceless. Our comprehensive liability insurance covers every visit.',
  },
  {
    id: 'guarantee',
    title: 'Satisfaction Guarantee',
    description: 'Not happy with the result? We will re-clean at no extra charge within 48 hours. No questions, no hassle.',
  },
  {
    id: 'punctual',
    title: 'On-Time, Every Time',
    description: 'We respect your schedule. Our crews arrive within a confirmed 30-minute window — and we notify you when they are en route.',
  },
  {
    id: 'training',
    title: 'Trained Professionals',
    description: 'Every cleaner completes a rigorous training programme covering technique, etiquette, safety protocols, and customer care.',
  },
];

export const faqItems = [
  {
    question: 'How do I book a cleaning?',
    answer: 'Click "Book a Cleanup" anywhere on the site, choose your service, fill in your details, and select a date and time. You will receive an instant confirmation.',
  },
  {
    question: 'What areas do you currently serve?',
    answer: 'We operate across Lagos (Lekki, Victoria Island, Ikeja, Yaba, Surulere, Gbagada), Abuja (Maitama, Wuse, Garki, Jabi), Port Harcourt (GRA Phase 1 & 2, Trans Amadi), and Ibadan (Ring Road, Bodija, Moniya).',
  },
  {
    question: 'Are your products safe for kids and pets?',
    answer: 'Absolutely. We exclusively use non-toxic, biodegradable, and hypoallergenic products. No bleach, no ammonia, no harmful fumes — just effective, safe cleaning.',
  },
  {
    question: 'What if I am not satisfied with the cleaning?',
    answer: 'Our satisfaction guarantee means we will return and re-clean any area you are not happy with, completely free, within 48 hours of the original visit.',
  },
  {
    question: 'Do I need to be home during the cleaning?',
    answer: 'Not at all. Many clients provide access instructions or a spare key. Our crews are background-checked, uniformed, and trained to respect your privacy and property.',
  },
  {
    question: 'How are your prices determined?',
    answer: 'Pricing depends on the type of service, the size of the space, and the scope of work. You will see a clear estimate before confirming any booking — no hidden fees.',
  },
];

export const coverageAreas = [
  {
    city: 'Lagos',
    neighbourhoods: ['Lekki', 'Victoria Island', 'Ikeja', 'Yaba', 'Surulere', 'Gbagada'],
  },
  {
    city: 'Abuja',
    neighbourhoods: ['Maitama', 'Wuse', 'Garki', 'Jabi'],
  },
  {
    city: 'Port Harcourt',
    neighbourhoods: ['GRA Phase 1', 'GRA Phase 2', 'Trans Amadi'],
  },
  {
    city: 'Ibadan',
    neighbourhoods: ['Ring Road', 'Bodija', 'Moniya'],
  },
];